import React, { useCallback } from 'react';
import { Alert, Box, MenuItem, TextField } from '@mui/material';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { isLocale, supportedLocales, useLocale } from '../../i18n';

const containerStyles = { width: '100%', p: 1 };
const selectorStyles = { width: '100%', minWidth: 140 };
const errorStyles = { mt: 1 };
const languageMessages = defineMessages({
  en: { id: 'language.en', defaultMessage: 'English' },
  cs: { id: 'language.cs', defaultMessage: 'Čeština' },
});

export const LanguageSelector = React.memo(function LanguageSelector() {
  const intl = useIntl();
  const { locale, changeLocale, changingLocale, localeError } = useLocale();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const nextLocale = event.target.value;

      if (isLocale(nextLocale)) {
        void changeLocale(nextLocale);
      }
    },
    [changeLocale]
  );

  return (
    <Box sx={containerStyles}>
      <TextField
        select
        disabled={changingLocale}
        label={intl.formatMessage({
          id: 'language.change',
          defaultMessage: 'Change language',
        })}
        size="small"
        sx={selectorStyles}
        value={locale}
        onChange={handleChange}
      >
        {supportedLocales.map((supportedLocale) => (
          <MenuItem key={supportedLocale} value={supportedLocale}>
            {intl.formatMessage(languageMessages[supportedLocale])}
          </MenuItem>
        ))}
      </TextField>
      {localeError ? (
        <Alert severity="error" sx={errorStyles}>
          <FormattedMessage
            id="language.saveError"
            defaultMessage="The language could not be saved. Please try again."
          />
        </Alert>
      ) : null}
    </Box>
  );
});

export { UserMenuLanguageSwitcher } from './UserMenuLanguageSwitcher';
